export default __webpack_public_path__ + "static/media/(67).8ce78644.jpg";